export default {
  get name(): string {
    return 'ExpoHaptics';
  },
};
